import React from 'react';
import Toaster from 'toastr';
import Modal from '../../common/modal';
import Messages from '../../../configurations/messages';
import Constants from '../../../configurations/constants';
import SettlementsApi from '../../../api/SettlementsApi';

class SettlementRequestCancelModal extends React.Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            requestReference: props.requestReference,
            cancelling: false,
            reason: ""
        }

        this.modalStyle = {
            ovelay: {},
            content: {
                top: "80px",
                left: "250px",
                right: "250px",
                bottom: "100px",
                zIndex: "1000"
            }
        }
        this.onTextInputChange = this.onTextInputChange.bind(this);
        this.handleAction = this.handleAction.bind(this);
    }

    onTextInputChange(evt) {
        this.setState({
            reason: evt.target.value || ""
        });

    }
    handleAction(evt) {
        let reference = this.state.requestReference;
        this.setState({
            cancelling: true
        })
        SettlementsApi.processSettlementRequest(reference, {
            action: Constants.SETTLEMENT_REQUEST_ACTION_CANCEL,
            reason: this.state.reason
        })
            .then(response => {
                Toaster.success(`${Messages.SUCCESS_SETTLEMENT_REQUEST_CANCELED}`, `${reference}`);
                this.props.onRequestClose(evt, true);

            })
            .catch(error => {
                console.log(error);
                Toaster.error(`${error.data ? error.data.description : error.statusText}`, `${error.status} - ${reference}`);
                this.setState({
                    cancelling: false
                })
            })
    }

    render() {

        return (
            <Modal title={`${this.state.requestReference}`} isOpen={this.props.isOpen} style={this.modalStyle} onRequestClose={this.props.onRequestClose}>
                <div className="mod-content">
                    <form>
                        <div className="row">
                            <div className="col-md-11">
                                <div className="form-div">
                                    <label>Reason :</label>
                                    <textarea
                                        id="reason"
                                        value={this.state.reason}
                                        onChange={this.onTextInputChange}
                                        placeholder="Enter Reason for cancelling"
                                        height="200px"
                                        maxLength="500"
                                    />
                                </div>

                            </div>
                        </div>
                    </form>
                </div>
                <div className="mod-footer">
                    <div className="mod-footer-buttons">
                        <button onClick={(evt) => { this.handleAction(evt) }} disabled={this.state.cancelling || !this.state.reason} className="btn btn-primary">CANCEL REQUEST</button>
                        <button onClick={(evt) => { this.props.onRequestClose(evt); }} disabled={this.state.cancelling} className="btn btn-danger">CLOSE</button>
                        
                    </div>
                </div>
            </Modal>


        )
    }
}

export default SettlementRequestCancelModal;



// WEBPACK FOOTER //
// ./src/components/admin/settlementRequests/settlementRequestCancelModal.js